import {createMultiStyleConfigHelpers} from '@chakra-ui/styled-system';

const helpers = createMultiStyleConfigHelpers([
  'root',
  'textContainer',
  'media',
  'group1',
  'group2',
  'text1',
  'text2',
  'text3',
  'text4'
]);

/**
 * @typedef {import('@chakra-ui/styled-system').SystemStyleObject} SystemStyleObject
 * @typedef {import('@chakra-ui/styled-system').PartsStyleInterpolation<{
 *  keys: ("root" | "textContainer" | "media" | "group1" | "group2" | "text1" | "text2" | "text3" | "text4")[]
 * }>} CarouselItemStyles
 */
export const carouselItemStyles = helpers.defineMultiStyleConfig({
  /**
   * @param {Object} args - Component arguments
   * @param {Contentful.CarouselItem} args.component - CarouselItem component data
   * @param {boolean} [args.isComplete] - Whether component has all fields
   * @param {boolean} [args.isFetching] - Whether additional data is being fetched
   *
   * @returns {CarouselItemStyles} - Component styles
   */
  baseStyle: ({component}) => {
  },
  variants: {
    /**
     * @param {Object} args - Component arguments
     * @param {Contentful.MediaCarousel} args.component - MediaCarousel component data
     * @param {boolean} [args.isComplete] - Whether component has all fields
     * @param {boolean} [args.isFetching] - Whether additional data is being fetched
     *
     * @returns {MediaCarouselStyles} - Component styles
     */
    'CF-011': (args) => ({
      text1: {
        color: 'white',
        fontSize: {base: '28px', lg: '40px'},
        fontWeight: 500,
        left: '50%',
        letterSpacing: {base: '-0.28px', lg: '-0.4px'},
        lineHeight: 'shorter',
        position: 'absolute',
        textAlign: 'center',
        top: {base: '45px', lg: '40%'},
        transform: {base: 'translate(-50%, 0)', lg: 'translate(-50%, -50%)'},
        width: {base: 'calc(100% - 40px)', lg: '80%'},
        zIndex: 1,
      },
    }),

    'CF-012.01': (args) => ({
      group1: {
        display: 'flex',
        flexDirection: 'column',
        gap: '12px',
        textAlign: 'center',
      },
      group2: {
        display: 'flex',
        flexDirection: {base: 'column', lg: 'row'},
        gap: '40px',
      },
      text1: {
        fontSize: {base: '12px', lg: '14px'},
        fontWeight: '500',
        letterSpacing: {base: '1.2px', lg: '1.4px'},
        textTransform: 'uppercase',
      },
      text2: {
        fontSize: {base: '28px', lg: '46px'},
        fontWeight: '500',
        lineHeight: 'shorter',
      },
      text3: {
        flex: 1,
        fontSize: {base: '24px', lg: '28px'},
        fontWeight: '500',
        letterSpacing: {base: '1.2px', lg: '1.4px'},
        lineHeight: 'shorter',
      },
      text4: {
        flex: 1,
        fontSize: {base: '12px', lg: '18px'},
        letterSpacing: {lg: '-0.18px'},
      },
      textContainer: {
        color: 'white',
        display: 'flex',
        flexDirection: 'column',
        gap: '180px',
        height: '100%',
        left: {base: '20px', lg: '20%'},
        position: 'absolute',
        top: {base: '48px', lg: '120px'},
        width: {base: 'calc(100% - 43px)', lg: '60%'},
        zIndex: 10,
      },
    }),

    /**
     * @param {Object} args - Component arguments
     * @param {Contentful.MediaCarousel} args.component - MediaCarousel component data
     * @param {boolean} [args.isComplete] - Whether component has all fields
     * @param {boolean} [args.isFetching] - Whether additional data is being fetched
     *
     * @returns {MediaCarouselStyles} - Component styles
     */
    'CF-013': (args) => ({
      group1: {
        margin: {base: '48px auto 8px', lg: '120px auto 46px'},
        textAlign: 'center',
        width: {base: '100%', lg: 'calc(100% - 600px)'},
        paddingX: [4, 4, 6, 6, 8, 8],
      },
      text1: {
        fontSize: {base: '12px', lg: '14px'},
        fontWeight: 500,
        letterSpacing: {base: '1.2px', lg: '1.4px'},
        marginBottom: '12px',
        textTransform: 'uppercase',
      },
      text2: {
        fontSize: {base: '28px', lg: '46px'},
        fontWeight: 500,
        lineHeight: 'shorter',
        marginBottom: '16px',
      },
      text3: {
        fontSize: {base: '16px', lg: '20px'},
        lineHeight: '150%',
      },
    }),
  },
});
